'use client';

import type { ReactNode } from 'react';

import { isDevelopment } from '@/lib/runtime-env';

/**
 * Mount point for development-only tooling (React Query Devtools, debug overlays, etc.).
 * Never renders children in production — the branch is eliminated from production bundles
 * when `NODE_ENV === 'production'` at build time.
 */
export function DevToolsProvider({ children }: { children?: ReactNode }) {
  if (!isDevelopment) {
    return null;
  }

  return <>{children ?? null}</>;
}
